import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import usePrivilegeCheck from "@common/hooks/usePrivilegeCheck";
import useAccountHasEntitlement from "@common/hooks/useAccountHasEntitlement";
import { List } from "./List/List";
import { New } from "./New/New";
import { Edit } from "./Edit/Edit";
import { Edit as BusinessEdit } from "./BusinessApprovals/Edit";
import { New as BusinessNew } from "./BusinessApprovals/New";
import { EntitlementBanner } from "./EntitlementBanner";

const ProjectApprovalV1Mspa = () => {
  const { hasPrivilege } = usePrivilegeCheck();
  const { hasEntitlement } = useAccountHasEntitlement();
  const { pathname } = useLocation();

  if (!hasPrivilege("settings.project_approval", ["create", "manage"])) {
    return (
      <div className="p-3">You do not have access to Project Approval.</div>
    );
  }

  const entitlement = hasEntitlement("workflow-approval");

  // The MSPA is mounted at both /admin/lob_approvals/* and
  // /admin/approval_levels/* (see App.js). The base path selects the resource
  // edited under the shared /new and /:id/edit URLs: approval_levels edits
  // ApprovalLevels (business), lob_approvals edits LobApprovals (technical).
  const isApprovalLevels = pathname.startsWith("/admin/approval_levels");

  return (
    <>
      {!entitlement && <EntitlementBanner />}
      <Routes>
        <Route index element={<List />} />
        <Route
          path="new"
          element={isApprovalLevels ? <BusinessNew /> : <New />}
        />
        <Route
          path=":id/edit"
          element={isApprovalLevels ? <BusinessEdit /> : <Edit />}
        />
        <Route path="*" element={<Navigate to="." replace />} />
      </Routes>
    </>
  );
};

export default ProjectApprovalV1Mspa;
